module.exports = " <div class=checkboxes-input> <div class=form-group> <label class=\"col-sm-4 control-label\"> {{ field.label }} <span v-if=field.required class=required>*</span> </label> <div class=col-sm-8> <div class=checkbox v-for=\"object in field.objects\"> <label> <input type=checkbox :value=object.uuid v-model=field.value :name=\"field.name + '[]'\"/> <strong>{{ object[field.objectName] }}</strong> </label> <br/> {{ object.description }} </div> </div> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/components/inputs/CheckboxesInput.vue
// module id = 726
// module chunks = 2